import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const ContributeContext = createContext();

export const ContributeProvider = ({ children, ...data }) => (
    <ContributeContext.Provider value={data}>{children}</ContributeContext.Provider>
);

ContributeProvider.propTypes = {
    subtotal: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,

    step: PropTypes.string.isRequired,
    referrer: PropTypes.string,
    type: PropTypes.oneOf(['pledge', 'donation']),
    amount: PropTypes.number,
    isBackpledging: PropTypes.bool.isRequired,
    tip: PropTypes.number,
    thirdPartyTermsAccepted: PropTypes.bool,
    token: PropTypes.string,

    user: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        street1: PropTypes.string,
        street2: PropTypes.string,
        city: PropTypes.string,
        stateProv: PropTypes.string,
        postalCode: PropTypes.string,
        country: PropTypes.string,
    }),

    campaign: PropTypes.shape({
        id: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,

        isDonationOnly: PropTypes.bool.isRequired,
        isComplete: PropTypes.bool.isRequired,

        pledgePresets: PropTypes.arrayOf(PropTypes.number),
        donatePresets: PropTypes.arrayOf(PropTypes.number).isRequired,

        metricName: PropTypes.shape({
            singular: PropTypes.string,
            plural: PropTypes.string,
        }),

        eventName: PropTypes.shape({
            singular: PropTypes.string,
            plural: PropTypes.string,
        }),

        stats: PropTypes.shape({
            performanceActualTotal: PropTypes.number,
            performanceRemaining: PropTypes.number,
            eventRemainingCount: PropTypes.number,
            eventFinalizedCount: PropTypes.number,
        }).isRequired,
    }).isRequired,
};

ContributeProvider.defaultProps = {
    referrer: null,
    type: null,
    amount: null,
    tip: null,
    user: null,
    thirdPartyTermsAccepted: null,
    token: null,
};

export const ContributeConsumer = ContributeContext.Consumer;
export default ContributeContext;
